import { render, staticRenderFns } from "./ListarOcorrencias.vue?vue&type=template&id=2f7a5b89&scoped=true"
import script from "./ListarOcorrencias.vue?vue&type=script&lang=js"
export * from "./ListarOcorrencias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7a5b89",
  null
  
)

export default component.exports